module.exports = __webpack_public_path__ + "img/registro_bg.6b74ea88.jpg";